var _circle, _circle2, _ellipse, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCool(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 102,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 98,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 100,
    rx: 80,
    ry: 79,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-4 100 105)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 92,
    width: 46,
    height: 30,
    rx: 6,
    fill: "#111",
    stroke: "#CC00CC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 94,
    width: 46,
    height: 30,
    rx: 6,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 96,
    width: 40,
    height: 26,
    rx: 6,
    fill: "#111",
    stroke: "#CC00CC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 98,
    width: 40,
    height: 26,
    rx: 6,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 107,
    x2: 104,
    y2: 107,
    stroke: "#CC00CC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 104,
    x2: 42,
    y2: 100,
    stroke: "#CC00CC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 106,
    x2: 156,
    y2: 102,
    stroke: "#CC00CC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 100,
    rx: 7,
    ry: 4,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 104,
    rx: 6,
    ry: 3,
    fill: "white",
    opacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 142 Q100 154 134 144",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 144 Q102 156 136 146",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCool);
export default __webpack_public_path__ + "static/media/cool.3b64bde58b8a694136e663c2d572edf3.svg";
export { ForwardRef as ReactComponent };